import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import ReplacementsForm from "components/Replacements/ReplacementsForm"

const Styled = {
  Wrapper: styled.div`
    text-align: left; /* flipped by mui */
  `,
  Title: styled(Typography)`
    margin-top: 40px;
  `,
  Subtitle: styled(Typography)`
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 20px;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-weight: bold;
    }
  `,
}

export const getStaticProps = StaticPropsFactory("replacements")

const Replacements = ({ seo }: StaticPropsFactoryProps) => {
  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Container>
        <Styled.Title variant="h1">מחירון מוצרי תעבורה (חלפים)</Styled.Title>
        <Styled.Subtitle>לחיפוש חלפים אנא הקלד את שם הפריט</Styled.Subtitle>
      </Container>
      <ReplacementsForm />
    </Styled.Wrapper>
  )
}

export default Replacements
